import * as $ from "jquery";
import {IAttributes, IAugmentedJQuery, IDirective, IDirectiveFactory, ILogService, IScope, ITimeoutService} from "angular";

export class DocumentViewerDirective implements IDirective {
    public link: (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes) => void;
    public restrict = "AE";
    public scope = true;

    /* @ngInject */
    public static factory(): IDirectiveFactory {
        const directive: IDirectiveFactory = ($timeout: ITimeoutService, $log: ILogService) => new DocumentViewerDirective($timeout, $log);
        directive.$inject = ["$timeout", "$log"];
        return directive;
    }

    /* @ngInject */
    constructor(private $timeout: ITimeoutService, private $log: ILogService) {
        $log.log("DocumentViewerDirective");
        DocumentViewerDirective.prototype.link = (scope: IScope, elem: IAugmentedJQuery, attrs: IAttributes) => {
            this.loadAttachment(attrs.attachment, attrs.type, elem[0]);
        };
    }

    public createElement(elementName, cssClass, container, innerHtml): any {
        const element = document.createElement(elementName);
        if (cssClass !== undefined && cssClass.length > 0) {
            element.className = cssClass;
        }
        if (container !== undefined) {
            container.appendChild(element);
        }
        if (innerHtml !== undefined) {
            element.innerHTML = innerHtml;
        }

        return element;
    }

    public loadAttachment(selectedAttachment, contentType, container) {

        while (container.hasChildNodes()) {
            container.removeChild(container.firstChild);
        }

        // Add preview element
        const spinElement = this.createElement("div", "preview-spin", container,
            "<i class='fa fa-spin fa-circle-o-notch'></i>");

        this.$log.debug("CONTENT TYPE");
        this.$log.debug(contentType);

        if (contentType === "application/pdf") {
            //we need to  download the attachment using a XMLHttpRequest as the gcsObjectName is not a link to a real file and the html
            //object tag won't render it correctly.
            const oReq: any = new XMLHttpRequest();
            oReq.open("GET", selectedAttachment, true);

            oReq.responseType = "blob";

            oReq.onload = (oEvent) => {
                // Remove preview element
                while (container.hasChildNodes()) {
                    container.removeChild(container.firstChild);
                }

                const blob: any = oReq.response;
                const url: any = URL.createObjectURL(blob);


                const element = this.createElement("div", "", container,
                    "<object data='" + url + "' type='" + oReq.response.type + "'>" +
                    "Unable to preview this file in your browser. Please download it manually</object>");
            };
            oReq.send();
        } else {
            while (container.hasChildNodes()) {
                container.removeChild(container.firstChild);
            }
            const element = this.createElement("div", "", container,
                "<img src='" +  selectedAttachment + "'>");
        }



    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/document-viewer.directive.ts